import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {ErrorPanelProps} from '@Panels/error-panel/error-panel';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'error-modal-panel';

export type ErrorModalProps = ErrorPanelProps;

export default function ErrorModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.ERROR_MODAL];
  });

  const height = '450px';
  const width = '560px';

  return (
    <Modal modalId={MODALS_IDS.ERROR_MODAL} panelId={PANEL_ID} modalHeight={height} modalWidth={width}>
      <LazyPanel
        panelDirectoryName="error-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openErrorModal = (props: ErrorModalProps = {}): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.ERROR_MODAL,
      panelProps: props,
    })
  );
};
